import type { OrganizationTeacher } from '../modules/teacher';
import { isTeacherCreatedManually } from '../modules/teacher';
import { useOrganization } from './use-organization';

type SchoolCapabilities = {
  contents: {
    canNavigateByGrade: boolean;
    canPerformDigitalPractice: boolean;
  };
  classrooms: {
    canCreateClassrooms: boolean;
    canCreateJourneys: boolean;
    canEdit: boolean;
    canOnlyAssignToClassrooms: boolean;
    showJourneys: boolean;
  };
  teachers: {
    canDelete(teacher: OrganizationTeacher): boolean;
  };
};

function useSchoolCapabilities(): SchoolCapabilities {
  const { isRosteringEnabled, isJourneysEnabled, isPlatformEnabled } =
    useOrganization();

  return {
    contents: {
      canNavigateByGrade: true,
      canPerformDigitalPractice: isPlatformEnabled,
    },
    classrooms: {
      canCreateClassrooms: !isRosteringEnabled,
      canCreateJourneys: isJourneysEnabled,
      canOnlyAssignToClassrooms: isRosteringEnabled,
      canEdit: !isRosteringEnabled,
      showJourneys: isJourneysEnabled,
    },
    teachers: {
      canDelete: (teacher: OrganizationTeacher) =>
        isTeacherCreatedManually(teacher),
    },
  };
}

export { useSchoolCapabilities };
